import { COOKIES } from '../../consts.js';
import { minifyString } from './index.js';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-var */
/* eslint-disable one-var */
/* eslint-disable vars-on-top */
/* eslint-disable func-style */
/* eslint-disable func-names */
/* eslint-disable dot-notation */
/* eslint-disable prefer-template */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-rest-params */
/* eslint-disable object-shorthand */
/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
const defineGoogleClientId = function (w, d, l, c, ga) {
    var m = d.cookie.match(RegExp('(?:^|;\\s*)' + c + '=([^;]*)'));
    var cookieValue = m ? m[1] : undefined;
    if (typeof cookieValue !== 'undefined') {
        var idFromCookie = cookieValue.split('.').slice(-2).join('.');
        if (typeof idFromCookie !== 'undefined') {
            w[l].push({ GoogleClientID: idFromCookie });
        }
        return;
    }
    if (typeof w[ga] !== 'undefined' && typeof w[ga].getAll === 'function') {
        var tracker = w[ga].getAll()[0];
        var idFromMemory = tracker.get('clientId');
        if (typeof idFromMemory !== 'undefined') {
            w[l].push({ GoogleClientID: idFromMemory });
        }
        return;
    }
};
const defineFromGTMToSravniTM = function (dataLayer) {
    const response = [`(${defineGoogleClientId.toString()})(window,document,'${dataLayer}','_ga', 'ga')`];
    return minifyString(response.join(';\n'));
};
// Используются для передачи параметров, характеризующих пользователя в целом.
// Эти параметры сохраняются и применяются ко всем последующим сессиям и действиям пользователя,
// что позволяет анализировать поведение на протяжении длительного времени.
const defineYandexUserParams = function (w, _d, l, yaid) {
    var dataObject = w[l].reduce(function (acc, data) {
        return Object.assign(acc, data);
    }, {});
    w.ym(yaid, 'userParams', {
        analyticsId: dataObject['analyticsId'],
        GoogleClientID: dataObject['GoogleClientID'],
        UserID: dataObject['SravniUserId'],
        anonymousId: dataObject['anonymousId'],
    });
};
// Используются для передачи параметров, относящихся к конкретному визиту или событию.
// Эти параметры применяются только к текущей сессии пользователя и
// могут быть использованы для сегментации и анализа поведения в рамках одного визита.
const defineYandexParams = function (w, _d, l, yaid) {
    var dataObject = w[l].reduce(function (acc, data) {
        return Object.assign(acc, data);
    }, {});
    w.ym(yaid, 'params', {
        theme: dataObject['theme'],
        UserID: dataObject['SravniUserId'],
        analyticsId: dataObject['analyticsId'],
        anonymousId: dataObject['anonymousId'],
        abTestingStatistics: dataObject['abTestingStatistics'],
    });
};
const defineFromSravniTMToYandexMetrics = function (dataLayer, yaid) {
    const response = [
        `(${defineYandexUserParams.toString()})(window,document,'${dataLayer}','${yaid}')`,
        `(${defineYandexParams.toString()})(window,document,'${dataLayer}','${yaid}')`,
    ];
    return minifyString(response.join(';\n'));
};
const defineSravniAnonymousId = function (w, d, l, c) {
    var m = d.cookie.match(RegExp('(?:^|;\\s*)' + c + '=([^;]*)'));
    var cookieValue = m ? m[1] : undefined;
    if (typeof cookieValue !== 'undefined') {
        w[l].push({ anonymousId: cookieValue });
        return;
    }
};
const defineFromSravniToSravniTM = function (dataLayer) {
    const response = [`(${defineSravniAnonymousId.toString()})(window,document,'${dataLayer}','${COOKIES.UUID}')`];
    return minifyString(response.join(';\n'));
};

export { defineFromGTMToSravniTM, defineFromSravniTMToYandexMetrics, defineFromSravniToSravniTM };
//# sourceMappingURL=dataConvertors.js.map
